'use strict';

/**
 * Determine Safari / Mobile Safari as well as Chrome iOS
 * @isomorphic
 *
 * @param {string=} ua
 * @return {boolean}
 */
exports.isSafariOrChromeIOS = function isSafariOrChromeIOS(ua = '') {
  return /(crios|version)\/([\w.]+).+?(mobile\s?safari|safari)/i.test(ua);
};
